import React from "react";

import stripMarkup from "~utils/stripMarkup";

interface TitleProps {
    className?: string;
    title?: string | null;
    titleUrl?: string;
}

export default function Title({ title = "", titleUrl, className }: TitleProps) {
    if (!title) {
        return null;
    }

    const cleanTitle = stripMarkup(title);

    return (
        <h3 data-component="title" className={className}>
            {titleUrl ? <a href={titleUrl}>{cleanTitle}</a> : cleanTitle}
        </h3>
    );
}
